import React from 'react';
import PropTypes from 'prop-types';
import {
  formatter,
  getFormattedPercentage
} from '../../common/globals.js';

const formatMonth = (month) => month[0] + month.slice(1, 3).toLowerCase();

function DataBlock({
  data, title, stickyStart, displaySales
}) {
  const formatBySales = (value) => {
    if (displaySales) {
      return formatter.format(value);
    }
    return value;
  };
  return (
    <>
      <h5
        className="optimize-section-subheader d-flex justify-content-between"
        style={{
          position: stickyStart ? 'sticky' : 'static',
          top: stickyStart ? `${stickyStart}px` : 'auto',
        }}
      >
        <div>{title}</div>
        <div>YTD: {getFormattedPercentage(data[0].YTD_Chg)}</div>
      </h5>
      <section style={{
        padding: '8px 8px 16px',
      }}
      >
        {
          data.map((item, index) => (
            <div key={index}>
              {item.type ? (
                <div
                  className="bg-theme"
                  style={{
                    paddingLeft: 8,
                    color: '#A6A6A6',
                    textDecorationLine: 'underline',
                    fontSize: 12,
                    backgroundColor: '#212121',
                    paddingTop: 4,
                    paddingBottom: 4,
                  }}
                >
                  {item.type}
                </div>
              ) : null}
              <table className="sales-table table">
                <thead>
                  <tr>
                    <th>YTD</th>
                    <th>{displaySales ? 'Sales' : 'Cases'}</th>
                    <th>Chg %</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{item.PY} Full Year</td>
                    <td>{formatBySales(item.SalesPY)}</td>
                    <td />
                  </tr>
                  <tr>
                    <td>{item.PY} YTD</td>
                    <td>{formatBySales(item.SalesPYTD)}</td>
                    <td />
                  </tr>
                  <tr>
                    <td>{item.CY} YTD</td>
                    <td>{formatBySales(item.SalesCYTD)}</td>
                    <td>
                      {item.YTD_Chg ? `${item.YTD_Chg.toFixed()}%` : null}
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="sales-table table">
                <thead>
                  <tr>
                    <th scope="col s1">MTD</th>
                    <th>Sales</th>
                    <th>Chg%</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{item.PY} {formatMonth(item.CM)}</td>
                    <td>{formatBySales(item.SalesPM)}</td>
                    <td />
                  </tr>
                  <tr>
                    <td>{item.PY} {formatMonth(item.CM)} MTD</td>
                    <td>{formatBySales(item.SalesPMTD)}</td>
                    <td />
                  </tr>
                  <tr>
                    <td>{item.CY} {formatMonth(item.CM)} MTD</td>
                    <td>{formatBySales(item.SalesCMTD)}</td>
                    <td>
                      {item.MTD_Chg ? `${item.MTD_Chg.toFixed()}%` : null}
                    </td>
                  </tr>
                </tbody>
              </table>
              {
                displaySales ? (
                  <table className="sales-table table">
                    <thead>
                      <tr>
                        <th>Not Billed</th>
                        <th>Sales</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Not Billed</td>
                        <td>{formatter.format(item.NotBilled)}</td>
                        <td className="hidden" />
                      </tr>
                    </tbody>
                  </table>
                ) : null
              }
            </div>
          ))
        }
      </section>
    </>
  );
}

DataBlock.defaultProps = {
  stickyStart: 0,
  displaySales: true
};

DataBlock.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    PY: PropTypes.string,
    CY: PropTypes.string,
    SalesPY: PropTypes.number,
    SalesPYTD: PropTypes.number,
    SalesCYTD: PropTypes.number,
    CM: PropTypes.string,
    SalesPM: PropTypes.number,
    SalesPMTD: PropTypes.number,
    SalesCMTD: PropTypes.number,
    NotBilled: PropTypes.number,
    YTD_Chg: PropTypes.number,
    MTD_Chg: PropTypes.number,
    type: PropTypes.string,
  })).isRequired,
  title: PropTypes.string.isRequired,
  stickyStart: PropTypes.number,
  displaySales: PropTypes.bool
};

export default DataBlock;
